export default {
	dev: {
		attendees: [
			{
				"name": "Jose Cabrera"
				,"email": "jcabrera@bienparabien.com"
			}
		],
		catalogos:{
			fondeadores:6,
			tipo_fondeo:13,
		}
	}
	,local: {
		attendees: [
			{
				"name": "Jose Cabrera"
				,"email": "jcabrera@bienparabien.com"
			}
		],
		catalogos:{
			fondeadores:6,
			tipo_fondeo:13,
		}		
	}
	,test: {
		attendees: [
			{
				"name": "Jose Cabrera"
				,"email": "jcabrera@bienparabien.com"
			}
		],
		catalogos:{
			fondeadores:6,
			tipo_fondeo:13,
		}
	}
	,production: {
		attendees: [
			{
				"name": "María Fernanda Rodríguez Ramírez"
				,"email": "mfrodriguez@bienparabien.com"
			}
		],
		catalogos:{
			fondeadores:6,
			tipo_fondeo:13,
		}
	}
}